<template>
  <div class="page">

    <div>
        <van-list
                v-model="loading"
                :finished="listFinished"
                finished-text="没有更多了"
                @load="loadData"
        >
        <div class="ranking-list">
            <div v-for="(item, index) in list" :key="index" v-if="item.isShow == true" class="item">
                <div class="avatar-wrap">
                    <img class="avatar" :src="item.clerkAvatarUrl">
                </div>
                <div class="content">
                    <div class="msg">【{{item.clerkName}}】收到了用户打赏的<span class="amount">{{formatPrice(item.totalAmount)}}</span>元~</div>
                    <div class="time">{{formatDate(item.createTime)}}</div>
                </div>
            </div>
        </div>
        </van-list>
    </div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import { List, Cell, CellGroup, Toast, Dialog } from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  moment.locale('zh-CN');
  import { getRewardLogList } from '@/api/clerk/order'

  Vue.use(List)
      .use(Cell)
      .use(CellGroup)
      .use(Toast)
      .use(Dialog)

  export default {
    name: 'reward-log',
    data () {
      return {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: false,
        listFinished: false,
      }
    },
    methods: {
      formatDate(date) {
        if (!date) {
          return '';
        }
        return moment(date).fromNow();
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      loadData(resetFirstPage) {
        // 重置为首页
        if (resetFirstPage) {
          this.pageNo = 1
        }
        // 清空数据
        if (this.pageNo == 1) {
          this.list = [];
        }
       this.loading = true
        getRewardLogList(
          this.pageNo,
          this.pageSize
        ).then(res => {
          this.loading = false
          const data = res.data;
          if (data.code == 0) {
            this.list = this.list.concat(data.list)
            if (data.hasNextPage) {
              this.listFinished = false
            } else {
              this.listFinished = true
            }
          } else {
            this.listFinished = true
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
          this.pageNo ++
        })
      }
    },
    mounted() {
      // this.loadData()
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>

    .page {
        padding: 10px;
        .ranking-list {
            .item {
                margin-top: 10px;
                padding: 10px 15px;
                background: #fff;
                border-radius: 10px;
                display: flex;
                align-items: center;
                .avatar-wrap {
                    position: relative;
                    .avatar {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                    }
                }
                .content {
                    margin-left: 8px;
                    flex: 1;
                    .msg {
                        color: #333;
                        font-size: 14px;
                        .amount {
                            margin: 0 2px;
                            color: #000;
                            font-weight: bold;
                        }
                    }
                    .time {
                        font-size: 12px;
                        color: #999;
                        margin-top: 5px;
                        margin-left: 5px;
                    }
                }
            }
        }

    }
</style>
